// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"d52fd361","592":"5dbf1eb1","828":"64d7ba15"}[chunkId] + ".chunk.js";
};